import React from 'react';
import {
  Box, List, ListItem, ListItemButton, ListItemText, Typography, Divider, Paper,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { MenuBook as TocIcon } from '@mui/icons-material';
import { MP } from './manualPalette';

const ManualTableOfContents = ({ chapters, activeChapter }) => {
  const scrollTo = (id) => {
    const el = document.getElementById(`chapter-${id}`);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <Paper
      elevation={0}
      sx={{
        border: `1px solid ${alpha(MP.yellow, 0.3)}`,
        borderRadius: 2,
        overflow: 'hidden',
        position: 'sticky',
        top: 80,
        maxHeight: 'calc(100vh - 120px)',
        overflowY: 'auto',
        bgcolor: MP.black,
        '&::-webkit-scrollbar': { width: 4 },
        '&::-webkit-scrollbar-thumb': { bgcolor: MP.yellow, borderRadius: 2 },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          px: 2,
          py: 1.5,
          background: `linear-gradient(90deg, ${MP.deepBlue} 0%, ${MP.blue} 100%)`,
          borderBottom: `2px solid ${MP.yellow}`,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <TocIcon sx={{ color: MP.yellow, fontSize: 18 }} />
        <Typography variant="subtitle2" fontWeight={800} sx={{ color: MP.white, letterSpacing: 0.5 }}>
          Contents
        </Typography>
      </Box>

      <List dense disablePadding>
        {chapters.map((ch, idx) => {
          const isActive = activeChapter === ch.id;
          return (
            <ListItem key={ch.id} disablePadding>
              <ListItemButton
                onClick={() => scrollTo(ch.id)}
                sx={{
                  py: 0.8,
                  px: 1.5,
                  bgcolor: isActive ? alpha(MP.yellow, 0.12) : 'transparent',
                  borderLeft: isActive ? `3px solid ${MP.yellow}` : `3px solid transparent`,
                  '&:hover': { bgcolor: alpha(MP.blue, 0.3) },
                }}
              >
                <Box
                  sx={{
                    minWidth: 22,
                    height: 18,
                    bgcolor: isActive ? MP.yellow : alpha(MP.yellow, 0.2),
                    color: isActive ? MP.black : MP.yellow,
                    borderRadius: 0.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.62rem',
                    fontWeight: 800,
                    mr: 1.25,
                    flexShrink: 0,
                  }}
                >
                  {idx + 1}
                </Box>
                <ListItemText
                  primary={ch.title}
                  primaryTypographyProps={{
                    variant: 'caption',
                    fontWeight: isActive ? 700 : 400,
                    color: isActive ? MP.yellow : MP.textMuted,
                    lineHeight: 1.4,
                    fontSize: '0.72rem',
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
};

export default ManualTableOfContents;
